import React, { useEffect } from "react";
import styled from "styled-components";
import css from "@styled-system/css";
import { Box, LinkButton, Typography } from "@bca/ui-library";

import ExclamationCircleSVG from "./Icons/ExclamationCircleSVG";
import accountErrorDataPush from "./AdobeDataPushes/errors/accountErrorDataPush";

const Container = styled(Box)`
  width: 100%;
  margin-left: auto;
  margin-right: auto;
  ${css({
    maxWidth: ["100%", "100%", "100%", 1440],
    px: [5, 5, 60, 60],
  })}
`;

const AccountErrorPage = () => {
  useEffect(() => {
    accountErrorDataPush();
  }, []);

  return (
    <Container
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      minHeight="calc(100vh - 710px)"
      paddingY={60}
    >
      <ExclamationCircleSVG width="fit-content" fill="primary-red" />
      <Typography variant="h4" htmlTag="h2" my={6} textAlign="center">
        There’s an issue with your account
      </Typography>
      <Typography
        variant="body-lg"
        m={0}
        mb={40}
        color="grey-blue"
        textAlign="center"
        css={`
          max-width: 530px;
        `}
      >
        We seem to have encountered an error in your account, to use this page
        and other online services please contact support.
      </Typography>
      <LinkButton
        link={`${process.env.VIRTUAL_DOMAIN}contact/`}
        shouldOpenInNewWindow={false}
        variant="secondary"
        width="100%"
        maxWidth={210}
        height={60}
        fontSize="body-lg"
        fontWeight={100}
        data-en="click"
        data-ec="button"
        data-el="contact-support"
        data-ea="navigate"
      >
        Contact Support
      </LinkButton>
    </Container>
  );
};

export default AccountErrorPage;
